import { useEffect, useState } from 'react';
import { useEditorNavigate, useEditorSearch } from 'app/router/params';

export const useRevisionL = (): [string | null, (value: string | null) => void] => {
  const navigate = useEditorNavigate();
  const revisionR = useEditorSearch().revisionR;
  const [revisionL, setRevisionL] = useState<string | null>(useEditorSearch().revisionL ?? null);

  useEffect(() => {
    navigate({ hash: true, search: (prev) => ({ ...prev, revisionL: revisionL || undefined, revisionR: revisionR || undefined }) });
  }, [revisionL, revisionR, navigate]);

  return [revisionL, setRevisionL];
};

export const useRevisionR = (): [string | null, (value: string | null) => void] => {
  const navigate = useEditorNavigate();
  const revisionL = useEditorSearch().revisionL;
  const [revisionR, setRevisionR] = useState<string | null>(useEditorSearch().revisionR ?? null);

  useEffect(() => {
    navigate({ hash: true, search: (prev) => ({ ...prev, revisionL: revisionL || undefined, revisionR: revisionR || undefined }) });
  }, [revisionL, revisionR, navigate]);

  return [revisionR, setRevisionR];
};
